import Vue from 'vue'

export default (name, options) => {
  return {
    validator: (value) => {
      if (options.includes(value)) {
        return true
      }

      const optionsStr = options.join(', ')

      Vue.util.warn(
        `The ${name} prop is invalid. Given value: ${value}. Available options: ${optionsStr}.`,
        this
      )

      return false
    }
  }
}
